export const DISPLAY_FACT_FIND = 'DISPLAY_FACT_FIND';
export const GAME_PLAN_GENERATE = 'GAME_PLAN_GENERATE';
export const DISPLAY_DOCUMENTS = 'DISPLAY_DOCUMENTS';
export const APPLICATION_LOADING_TIME = 3000;
